import {RequestFormType} from "../const/const"
import RequestFormField from "../../../../core/model2/form/settings/field"
import {PublicRequestFrom_FieldEmail, PublicRequestFrom_FieldName, PublicRequestFrom_FieldTitle} from "../@const"

// const debug = "getMandatoryFormFields"
const debug = false

export default function getMandatoryFormFields(requestFormType:RequestFormType) {
    let requestFormFields = []

    switch (requestFormType) {
        case RequestFormType.FORM:
            /** USER NAME FIELD **/
            const requestFormFieldName = new RequestFormField(PublicRequestFrom_FieldName)
            requestFormFields.push(requestFormFieldName)

            /** USER EMAIL FIELD **/
            const requestFormFieldEmail = new RequestFormField(PublicRequestFrom_FieldEmail)
            requestFormFields.push(requestFormFieldEmail)
            break
    }

    /** REQUEST TITLE FIELD **/
    const requestFormField = new RequestFormField(PublicRequestFrom_FieldTitle)
    requestFormFields.push(requestFormField)

    return requestFormFields
}